import type { AmwayHighlightsProps } from '../../../components/AmwayHighlights/AmwayHighlights';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
const transformAmwayHighlights = (data: CMSTransformerDataType): AmwayHighlightsProps => {
  const amwayHighlights = Array.isArray(data.amway_highlights) ? data.amway_highlights[0] : data.amway_highlights;
  const amwayHighlightsData = amwayHighlights.items.map((item: CMSTransformerDataType) => ({
    images: item.image.images,
    description: item.description,
    title: item.title,
  }));
  return {
    componentType: ComponentType.amway_highlights,
    amwayHighlightsData,
  };
};

export default transformAmwayHighlights;
